
module.exports = [
  'M0 6 L8 6 L10 2 L22 2 L24 6 L32 6 L32 28 L0 28 z M9 17 A7 7 0 0 0 23 17 A7 7 0 0 0 9 17'
].join(' ')




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/paths/camera.js
// module id = 311
// module chunks = 6